var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 33,
    viewBox: "0 0 19 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7552 13.0001H12.5053V8.00012C12.5053 6.62013 13.6253 6.75013 15.0052 6.75013H17.5052V0.500183H12.5053C8.3628 0.500183 5.00533 3.85765 5.00533 8.00012V13.0001H0.00537109V19.25H5.00533V32.9999H12.5053V19.25H16.2552L18.7552 13.0001Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookF);
export default __webpack_public_path__ + "static/media/FacebookF.200d430ad8d4a1454683d8b5f8e153fe.svg";
export { ForwardRef as ReactComponent };